import { atom } from 'jotai';
import { selectAtom } from 'jotai/utils';
import { reduxAtom } from '../redux-atoms';

export const vendorAtom = atom((get) => {
	const { vendor } = get(reduxAtom);
	return vendor?.vendor;
});

export const isLiteStorefrontAtom = atom((get) => {
	const vendor = get(vendorAtom);
	return Boolean(vendor?.purchaseStatus !== 'PAID');
});

export const isVenueAtom = selectAtom(
	reduxAtom,
	(state) => state.vendor?.vendor?.categoryCode === 'REC',
);

export const aiCostBreakdownAtom = selectAtom(
	reduxAtom,
	(state) => state.vendor?.vendorRaw?.ai?.costBreakdown ?? null,
);
